import { useEffect } from 'react';

const DEFAULT_DOCUMENT_TITLE = 'Cognidaily - Daily Competitive Trivia';

const useDocumentTitle = (title?: string) => {
  useEffect(() => {
    const nextTitle = title ?? DEFAULT_DOCUMENT_TITLE;
    document.title = nextTitle;

    return () => {
      if (!title) {
        document.title = DEFAULT_DOCUMENT_TITLE;
      }
    };
  }, [title]);
};

export default useDocumentTitle;
export { DEFAULT_DOCUMENT_TITLE };



















